/**
 * Displays infographic content for guidance.
 */
import { Box } from "@mui/material";
import Infography from "../../../../assets/Images/AdvisorHelpers/Infografia.jpg";

type InfographyContentProps = {
  paymentMode?: boolean;
};

const InfographyContent = ({ paymentMode = false }: InfographyContentProps) => (
  <Box
    sx={{
      ...(paymentMode
        ? {
            alignItems: "center",
            bgcolor: "#F6F6F6",
            display: "flex",
            height: "100%",
            justifyContent: "center",
            minHeight: "100%",
            position: "relative",
            width: "100%",
            maxWidth: "100%",
            zIndex: 1,
          }
        : {
            alignItems: "center",
            bgcolor: "white",
            display: "flex",
            height: "100vh",
            justifyContent: "center",
            left: 0,
            padding: 0,
            position: "fixed",
            top: 0,
            width: "100vw",
            zIndex: 10,
          }),
    }}
  >
    <Box
      component="img"
      src={Infography}
      alt="Infography"
      sx={{
        height: paymentMode ? "calc(100vh - 140px)" : "100vh",
        maxWidth: "100%",
        objectFit: "contain",
        width: "100%",
      }}
    />
  </Box>
);

export default InfographyContent;
